import { Box } from "@material-ui/core";
import { LegendBoxList, LegendCssIcoListItem } from "../../legend/LegendBoxComponents";
import { memo } from "react";

function LegendSsScale() {
  return (
    <>
      <Box sx={{minWidth: 75}}>
        <LegendBoxList>
          <LegendCssIcoListItem background={"rgb(255, 0, 0)"} text="5: OVC"></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(255, 255, 0)"} text="4: BKN"></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(0, 255, 0)"} text="3: SCT"></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(0, 255, 255)"} text="2: FEW"></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(0, 102, 255)"} text="1: SKC"></LegendCssIcoListItem>
        </LegendBoxList>
      </Box>
    </>
  )
}

export default memo(LegendSsScale);